
import Content from "@/components/Content";import { WithUserLayout } from "@/components/UserLayout";
import { Page } from "@/types/Page";
import LoginForm from "@/components/Authentication/LoginForm";
import AuthenticationBackground from "@/components/Authentication/AuthenticationBackground";
import { useSearchParams } from "next/navigation";

const LoginPage: Page = () => {

    const queryParameters = useSearchParams();

    const errorMessage = queryParameters.has("error") ? "Sorry, unexpected error when login. Please try again" : "";
    
    return (
        <AuthenticationBackground>
            <Content>
               <LoginForm errorMessage={errorMessage} />
            </Content>
        </AuthenticationBackground>
    );
}

LoginPage.layout = WithUserLayout;
export default LoginPage;
